import React, { useState } from 'react';
import './FAQ.css';
import angleRightIcon from '../assets/icons/angle-right.svg';

const FAQ = ({ appData }) => {
  const [openQuestion, setOpenQuestion] = useState(null);

  // Получаем FAQ из конфига или используем fallback
  const questions = appData?.faq || [];

  const handleQuestionClick = (questionId) => {
    // Добавляем небольшую задержку для предотвращения ошибок ResizeObserver
    setTimeout(() => {
      if (openQuestion === questionId) {
        setOpenQuestion(null);
      } else {
        setOpenQuestion(questionId);
      }
    }, 0);
  };

  return (
    <div className="faq-container">
      {questions.length > 0 ? (
        <div className="faq-list">
          {questions.map((item) => (
            <div 
              key={item.id} 
              className={`faq-item ${openQuestion === item.id ? 'open' : ''}`}
              onClick={() => handleQuestionClick(item.id)}
            >
              <div className="faq-question">
                <div className="question-text">{item.question}</div>
                <div className="question-arrow">
                  <img 
                    src={angleRightIcon} 
                    alt="Раскрыть" 
                    className={openQuestion === item.id ? 'rotated' : ''}
                  />
                </div>
              </div>
              {openQuestion === item.id && (
                <div className="faq-answer">
                  <div 
                    dangerouslySetInnerHTML={{ 
                      __html: item.answer 
                    }} 
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="faq-empty">
          <p>Здесь будут опубликован FAQ сообщества</p>
        </div>
      )}
    </div>
  );
};

export default FAQ; 